import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState, useEffect } from 'react';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

// Types - Make props compatible with react-modal-promise

const GeneralModal: React.FC<any> = ({
  isOpen = false,
  onResolve = () => {},
  onReject = () => {},
  title = '',
  body = '',
  showInput = false,
  showDate = false,
  placeHolder = '',
  existMessage = '',
}) => {
  const [message, setMessage] = useState<string>('');
  const [date, setDate] = useState<string>('');

  useEffect(() => {
    if (existMessage?.length) {
      setMessage(existMessage);
    }
  }, [existMessage]);

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => onResolve({ decision: true, message, date })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          className: `w-full !max-w-md mx-auto !rounded-xl shadow-2xl bg-white`,
        }}
      >
        {/* Title */}
        <DialogTitle id="alert-dialog-title" className="text-lg !font-semibold !text-gray-700 text-center bg-gray-100 px-6 pt-4">
          {title}
        </DialogTitle>

        {/* Body */}
        <DialogContent className="px-6 pb-4 pt-2">
          <DialogContentText id="alert-dialog-description" className="text-sm text-gray-600 text-center">
            {body}
          </DialogContentText>

          {/* Optional Input */}
          {showInput && (
            <TextareaAutosize
              value={message}
              className="mt-4 w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-700 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
              minRows={3}
              onChange={(ev: React.ChangeEvent<HTMLTextAreaElement>) => setMessage(ev.target.value)}
              placeholder={placeHolder}
            />
          )}

          {showDate  && (
            <div className="relative max-w-sm">
  <label className="mt-3 block mb-2 text-sm font-medium text-red-400 text-center font-bold">{placeHolder} </label>
    <input type="datetime-local" className="border border-gray-300 p-2 rounded-md focus:ring-blue-500 focus:border-blue-500"
               onChange={(ev: React.ChangeEvent<HTMLInputElement>) => setDate(ev.target.value)}
               />
</div>
            
         
        


          )}
        </DialogContent>

        {/* Actions */}
        <DialogActions className="px-6 pb-4 bg-gray-50 justify-center">
          <Button
            variant="outlined"
            color="error"
            onClick={() => onResolve({ decision: false, message, date })}
            className="!capitalize focus:outline-none"
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={() => onResolve({ decision: true, message, date })}
            className="!capitalize focus:outline-none mr-2"
            autoFocus
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GeneralModal;
